export function getBaseUrl() {
  // 1. Production: use canonical domain if set
  if (process.env.VERCEL_ENV === "production") {
    // Use your canonical domain, ideally from an env var
    return process.env.NEXT_PUBLIC_SITE_URL || "https://agnos.ai"
  }
  // 2. Preview/branch: use Vercel's preview URL
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`
  }
  // 3. Local dev fallback
  return "http://localhost:3000"
}
